<template>
  <div class="role-box">
    <div class="user-manage">
      <div class="top">
        <div class="left">角色管理</div>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号"> </el-table-column>
          <el-table-column prop="roleName" label="角色名称"> </el-table-column>
          <el-table-column prop="roleDescribe" label="描述"> </el-table-column>
          <el-table-column prop="edit" label="操作" width="120">
            <template slot-scope="scope">
              <div class="btn-out-box">
                <div
                  class="btn-box color1"
                  title="编辑"
                  @click="setUser(scope.row)"
                >
                  <i class="iconfont icon-bianji1"></i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="角色配置"
        :visible.sync="dialogFormVisible"
        :modal-append-to-body="false"
      >
        <el-form :label-position="'right'" label-width="120px" :model="form">
          <!-- <el-form-item label="角色名称：">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="角色描述：">
            <el-input type="textarea" :rows="5" v-model="form.describe">
            </el-input>
          </el-form-item> -->
          <el-form-item label="通用权限：">
            <el-checkbox-group v-model="form.fRule">
              <el-checkbox
                v-for="(item, index) in boxList"
                :key="index"
                :label="item.resourceId"
                >{{ item.resourceName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="bind">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>

import {
  Message
} from 'element-ui';
export default {
  data() {
    return {
      tableData: [
        {
          number: "1",
          name: "超级管理员",
          describe: "具备所有区域和菜单权限",
          isOpen: true,
        },
        {
          number: "2",
          name: "区域管理员",
          describe: "具备所有区域和菜单权限",
          isOpen: false,
        },
        {
          number: "3",
          name: "配电主管",
          describe: "能够配置所属项目下的用户权限",
          isOpen: false,
        },
        {
          number: "4",
          name: "值班室",
          describe: "能够配置所属项目下的用户权限",
          isOpen: false,
        },
        {
          number: "5",
          name: "巡检",
          describe: "某项目下，APP巡检上报权限，告警接收等",
          isOpen: false,
        },
      ],
      dialogFormVisible: false,
      form: {
        name: "",
        describe: "",
        fRule: [],
        bRule: [],
      },
      boxList: [],
      roleId: "",
    };
  },
  created() {
    this.managerDisRoleResource();
  },
  methods: {
    setUser(e) {
      // false 新增
      if (e) {
        // 编辑
        this.dialogFormVisible = true;
      } else {
        // 新增
        this.dialogFormVisible = true;
      }
      this.roleId = e.id;
      this.searchRoleResourcesForServiceName();
    },
    setShebei(e) {
      if (!e.isOpen) return;
      this.drawer = true;
    },
    // 获取角色列表
    managerDisRoleResource() {
      this.$http
        .post("/bma-user-service/role/searchRoleListByServiceName", {
          currentPage: 1,
          size: 10,
          serviceName: "配电平台",
        })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.records;
          }
        });
    },
    // 获取资源列表
    searchRoleResourcesForServiceName() {
      this.$http
        .post("/bma-user-service/role/searchRoleResourcesForServiceName", {
          roleId: this.roleId,
          serviceName: "配电平台",
        })
        .then((res) => {
          this.boxList = res.data;
        });
    },
    // 绑定
    bind() {
      this.dialogFormVisible = false;
      let param = this.form.fRule.join();
      this.$http
        .post("/bma-user-service/role/managerDisRoleResource", {
          roleId: this.roleId,
          resourceIds: param,
        })
        .then((res) => {
          if (res.code == 200) {
            Message.success("绑定成功");
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.role-box {
  padding: 20px;
}
.user-manage {
  background: #fff;
  padding: 20px;
  border-radius: 7px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 28px;
    .left {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .table-box {
    text-align: center;

    .el-table {
      background: rgba(0, 0, 0, 0);
      /deep/th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      /deep/th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      /deep/tr {
        td {
          font-size: 14px;
          color: #152139;
          text-align: center;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.color1:hover {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
        &.color2.active {
          background: rgba(255, 41, 41, 0.1);
          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }
        &.color3.active {
          background: rgba(253, 151, 101, 0.1);
          .iconfont {
            color: rgba(253, 151, 101, 1);
          }
        }
      }
    }
  }
  /deep/.el-dialog {
    width: 30%;
    .el-dialog__title {
      font-weight: 600;
    }
  }
}
</style>